import { SEVERITY } from "helpers/utils.js";
import {
  GET_STOCK_ADJUSTMENT_ITEMS,
  GET_STOCK_ADJUSTMENT_ITEMS_SUCCESS,
  GET_STOCK_ADJUSTMENT_ITEM_BY_ID_SUCCESS,
  GET_STOCK_ADJUSTMENT_ITEMS_ERROR,
  STOCK_ADJUSTMENT_ITEM_CLEAR_ERROR,
  GET_STOCK_ADJUSTMENT_ITEM_BY_ID,
  ADD_NEW_STOCK_ADJUSTMENT_ITEM,
  UPDATE_STOCK_ADJUSTMENT_ITEM,
  DELETE_STOCK_ADJUSTMENT_ITEM,
} from "./actionTypes.js";
const initState = {
  items: [],
  item: null,
  error: null,
  itemCount: 0,
  pageCount: 0,
  loading: false,
  message: null,
};

const StockInItem = (state = initState, action) => {
  const { type, payload } = action;

  switch (type) {
    case DELETE_STOCK_ADJUSTMENT_ITEM:
    case ADD_NEW_STOCK_ADJUSTMENT_ITEM:
    case UPDATE_STOCK_ADJUSTMENT_ITEM:
    case GET_STOCK_ADJUSTMENT_ITEMS:
      return {
        ...state,
        loading: true,
      };
    case GET_STOCK_ADJUSTMENT_ITEMS_SUCCESS:
      const { itemCount, pageCount, data } = payload;
      return {
        ...state,
        itemCount,
        pageCount,
        items: data,
        item: null,
        loading: false,
      };
    case GET_STOCK_ADJUSTMENT_ITEM_BY_ID:
      return {
        ...state,
        item: null,
      };
    case GET_STOCK_ADJUSTMENT_ITEM_BY_ID_SUCCESS:
      return {
        ...state,
        item: payload,
      };
    case GET_STOCK_ADJUSTMENT_ITEMS_ERROR:
      let hasUniqueCode = payload.includes("UNIQUE_ItemUnitOfMeasurement");
      return {
        ...state,
        message: {
          title: "Item",
          text: hasUniqueCode ? "Unit of Measurement already exist." : payload,
          severity: SEVERITY.DANGER,
        },
      };
    case STOCK_ADJUSTMENT_ITEM_CLEAR_ERROR:
      return {
        ...state,
        loading: false,
        message: null,
      };
    default:
      return state;
  }
};

export default StockInItem;
